import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import useNavigation from 'chameleon/ui-stack/hooks/useNavigation';
import {
  ALL_RESOURCES,
  getAssignmentStatuses,
} from 'chameleon-src/components/SidebarWrapperTwoLevels/constants';
import Header from 'chameleon/ui-stack/ui/page/header';
import { useTeacherOrganizeContext } from 'legacy-src/components/TeacherOrganize/hooks/useTeacherOrganize';
import TeacherAssignmentsContainer from './teacher';
import StudentAssignmentsContainer from './student';

const AssignmentsContainer = (props) => {
  const { userData, router } = props || {};
  const { isStudent, isTeacher, isAdmin, isCoordinator } = userData || {};
  const isProfessional = isTeacher || isAdmin || isCoordinator;

  const Component = isStudent
    ? StudentAssignmentsContainer
    : TeacherAssignmentsContainer;

  const ASSIGNMENTS_STATUSES = getAssignmentStatuses(isProfessional, isStudent);

  const { queryParams, params, replaceParamsInLocation } = useNavigation({
    router,
  });
  const { subject: masterSubject } = params || {};
  const { status, labels: filterLabels } = queryParams || {};

  // Whenever the `status` param is empty
  // Use the default one and replace the current URL
  useEffect(() => {
    if (isEmpty(status) && isEmpty(filterLabels)) {
      replaceParamsInLocation({
        status: isStudent ? 'assigned' : ALL_RESOURCES,
      });
    }
  }, []);

  const activeFilter = ASSIGNMENTS_STATUSES.find(
    ({ status: s, aliases = [] }) =>
      s === status ||
      status
        ?.split(',')
        .every((selectedStatus) =>
          aliases?.find((alias) => alias === selectedStatus),
        ),
  );

  let title = get(activeFilter, 'pageTitle') || '';
  let subtitle = isStudent ? 'ASSIGNMENTS' : 'RESOURCES & ASSIGNMENTS';
  const { subjectLabels } = useTeacherOrganizeContext({ masterSubject });

  if (filterLabels) {
    subtitle = isStudent ? 'TEACHER LABELS' : 'MY LABELS';
    const split_labels = filterLabels.split(',');
    if (split_labels.length === 1) {
      const { labels = {} } = subjectLabels;
      title = get(labels, `[${split_labels[0]}].name`, '');
    } else if (split_labels.length > 1) {
      title = 'MULTIPLE LABELS';
    }
  }

  return (
    <Fragment>
      <Header subtitle={subtitle} title={title} />
      <Component {...props} assignmentStatues={ASSIGNMENTS_STATUSES} />
    </Fragment>
  );
};

function mapStateToProps(state) {
  return {
    userData: state.userData,
  };
}

export default connect(mapStateToProps)(AssignmentsContainer);
